import { useState } from "react";
import { Editor, Transforms } from "slate";
import { CustomElement } from "../../../../../slate";
import { ReactEditor } from "slate-react";

interface IFootnote {
  footnote_text?: string;
  label?: string;
}

export const useFootnoteEdit = () => {
  const [editingContext, setEditingContext] = useState<{ editor: Editor, element: CustomElement } | null>(null);
  const [elementEdit, setElementEdit] = useState<IFootnote>({});

  const startEditing = (editor: Editor, element: CustomElement) => {
    setEditingContext({ editor, element });
    setElementEdit({ footnote_text: (element as any).footnote_text, label: (element as any).label });
  }

  const close = () => {
    setEditingContext(null);
    setElementEdit({});
  }

  const completeEditing = () => {
    if(!editingContext) {
      return null;
    }
    const { element, editor } = editingContext
    if(element && editor) {
      const path = ReactEditor.findPath(editor, element);
      Transforms.setNodes(
          editor,
          elementEdit as any,
          { at: path },
      );
    }
    close();
  }


  return {
    editingContext,
    elementEdit,
    update: (c: Partial<IFootnote>) => setElementEdit(x => ({ ...x, ...c })),

    startEditing,
    completeEditing,
    cancel: close,
  }

}


export type FootnoteEditData = ReturnType<typeof useFootnoteEdit>;